"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationClaim = exports.EmailClaim = void 0;
exports.EmailClaim = "https://app.q4inc.com/email";
exports.OrganizationClaim = "https://app.q4inc.com/organization";
